import { defineComponent as _defineComponent } from 'vue'
import { TextAlign } from '../types';
import { AbTitle, AbLink, AbIcon } from './ui';
import { CdnImg } from '@webplatform/cdn-image';

export interface TeamCardProps {
  image?: {
    src: string;
    alt: string;
  };
  name?: string;
  position?: string;
  description?: string;
  phones?: string[];
  email?: string;
  textAlign?: TextAlign;
  links?: [
    {
      link: string;
      text: string;
    },
    {
      link: string;
      text: string;
    }
  ];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TeamCard',
  props: {
    image: null,
    name: null,
    position: null,
    description: null,
    phones: null,
    email: null,
    textAlign: null,
    links: null
  },
  setup(__props: any) {



return { __sfc: true,AbTitle, AbLink, AbIcon, CdnImg }
}

})